"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AdminProfileView_1 = __importDefault(require("./AdminProfileView"));
exports.default = AdminProfileView_1.default;
